import Trip from "./components/trip/Trip";
import Forecast from "./components/forecast/Forecast";

function App() {
  return (
    <main>
      <Trip/>
      <Forecast/>
    </main>
  );
}

export default App;
